module.exports = __webpack_public_path__ + "static/img/cinemaTop.1ddb299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cinemaTop.png
// module id = Ddxf
// module chunks = 2